import React from 'react';
import {createRoot} from 'react-dom/client';
import ArticleOverviewModel from '../../models/article-overview-model';
import ArticleOverview from '../../components/overview/ArticleOverview.jsx';
import {Provider} from 'react-redux';
import createStore from "../../components/Store.jsx";
import JshModule from "@core/scripts/helper/jsh-module";

const {moduleScope} = JshModule('article-overview');

const articleOverview = ArticleOverviewModel.load();

const storeValues = createStore();
createRoot(moduleScope.parentNode).render(
    <Provider store={storeValues}>
        <ArticleOverview
            givenArticleContent={articleOverview.articleContent}
            givenFilterContent={articleOverview.filterContent}
            givenHeaderContent={articleOverview.headerContent}
            givenNavigationContent={articleOverview.navigationContent}
            givenLandmarkContent={articleOverview.landmarkContent}
            givenConfigurationContent={articleOverview.configurationContent}
            givenShopContent={articleOverview.shopContent}
            givenSearchResultContent={articleOverview.searchResultContent}
            givenSeoContent={articleOverview.seoContent}
            pointOfSaleId={articleOverview.pointOfSaleId}
            givenResponseLimitations={articleOverview.responseLimitations}
            givenRecommendationContent={articleOverview.recommendationContent}
            givenTeaserContent={articleOverview.teaserContent}
            givenSanitizedUrl={articleOverview.sanitizedUrl}
            givenRankingTrackingValue={articleOverview.rankingTrackingValue}
        />
    </Provider>
);
